/* eslint-disable @typescript-eslint/no-explicit-any */
import { useSessionStorage } from '@/hooks'
import { useParams } from 'react-router-dom'
import { useGetSearchParam } from '@/hooks'
import { useMemo } from 'react'
import { useGetAppPage } from '../components/AppPage2/useGetAppPage'
import { getMatchingFilters } from '../components/AppPage2/utils'

export function useGetFilterSelections() {
  const {
    data: { pageFilters },
  } = useGetAppPage()
  const { appKey } = useParams()
  const projectId = useGetSearchParam<number>('projectId')
  const [filterSelectionsPersisted] = useSessionStorage<Record<string, any>[]>(
    `/${appKey}/filters?pid=${projectId}`,
    []
  )
  const matchingFilters = useMemo(
    () => getMatchingFilters(filterSelectionsPersisted, pageFilters),
    [filterSelectionsPersisted, pageFilters]
  )
  return useMemo(
    () => ({
      filterSelections: matchingFilters,
      appKey,
      projectId,
    }),
    [appKey, matchingFilters, projectId]
  )
}
